import { Show, Text, View, hexColor } from "@lightningtv/solid";
import {
  hidePlaylistInfo,
  playListName,
  playListPassword,
  playListUrl,
  playListUsername,
} from "../../../../state";
import { t } from "../../../translations/configuration";

// Jetstream-style data card: subtle radius, dark surface, 3dp-ish white
// outline + slight scale on focus (same language as the Movies/Services
// cards) instead of a full color-fill flip.
const DataCard = (props: { label: string; value: string; width?: number }) => (
  <View
    style={{
      width: props.width ?? 380,
      height: 110,
      scale: 1,
      borderRadius: 10,
      color: hexColor("#1C1C1E"),
      border: { width: 0, color: hexColor("#00000000") },
      transition: {
        scale: { duration: 200, easing: "ease-in-out" },
        border: { duration: 150 },
      },
      focus: {
        scale: 1.04,
        border: { width: 3, color: hexColor("#ffffff") },
      },
    }}
  >
    <View
      x={22}
      y={22}
      style={{ display: "flex", flexDirection: "column", gap: 8, width: (props.width ?? 380) - 44 }}
    >
      <Text style={{ fontSize: 20, color: hexColor("#8E8E93") }}>{props.label}</Text>
      <Text
        contain="width"
        style={{
          fontSize: 26,
          color: hexColor("#ffffff"),
          maxLines: 1,
          width: (props.width ?? 380) - 44,
        }}
      >
        {props.value}
      </Text>
    </View>
  </View>
);

const truncate = (value: string, max: number) =>
  value.length > max ? `${value.substring(0, max)}...` : value;

const Account = (props: any) => {
  return (
    <View ref={props.ref} x={600} y={100} height={400} width={2000} clipping>
      <Text style={{ fontSize: 40, fontWeight: "bold", color: hexColor("#ffffff") }}>{t("playInfo")}</Text>

      {/* Dynamic card grid — one card per field, sized and spaced by flex
          instead of hand-placed at fixed x/y offsets */}
      <View
        y={90}
        style={{ display: "flex", flexDirection: "row", gap: 24, width: 1200 }}
      >
        <Show
          when={hidePlaylistInfo()}
          fallback={
            <>
              <DataCard label={t("username")} value={truncate(playListUsername(), 18)} />
              <DataCard label={t("password")} value={truncate(playListPassword(), 18)} />
            </>
          }
        >
          <DataCard label={t("playName")} value={truncate(playListName(), 18)} width={420} />
        </Show>
      </View>
    </View>
  );
};
export default Account;
